module.exports = __webpack_public_path__ + "images/disablethumb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/disablethumb.png
// module id = XPWi
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13